import React from 'react';
import './index.css';
import noDataFound from '../../../assets/images/icons/no-data-found.png';
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns'
import PartyName from './party-name';

function DataTable({ columns, data }) {

  const navigate = useNavigate();

  return (
    <div className='receipt-datatable border rounded'>
      <table className='table mb-0'>
        <thead className='table-head sticky-top'>
          <tr>
            {
              columns && columns.map((th_item, index) => {
                return (
                  <th key={index} className={index === 0 || index === columns.length - 2 ? 'text-start bg-table-head px-4' : index === columns.length - 1 ? 'text-end bg-table-head px-4' : 'text-center bg-table-head px-4'}>{th_item}</th>
                )
              })
            }
          </tr>
        </thead>
        {
          data && data.length > 0 ?
            <tbody>
              {
                data && data.map((item, index) => {
                  const formattedInvoiceIDs = item.invoiceIDs && item.invoiceIDs.map(x => x.id).join(", ").replace(/, ([^,]*)$/, " & $1");
                  return (
                    <tr key={index} className='border-top'>
                      <td className='align-middle px-4'>{new Date(item.date.seconds * 1000).toLocaleDateString("es-CL")}</td>
                      <td
                        className="align-middle px-4 cursor-pointer text-center text-primary"
                        onClick={() => navigate(`${item.id}`, { state: { id: item.id } })}
                      >
                        {item.id}
                      </td>
                      <td className="align-middle px-4 text-center w-25">{formattedInvoiceIDs}</td>
                      <td className="align-middle px-4 text-center">{item.bookingID}</td>
                      <td className="align-middle px-4 text-start">
                        <PartyName partyID={item.partyID} />
                      </td>
                      <td className="align-middle px-4 text-end">₹ {parseFloat(parseFloat(item.amountReceived).toFixed(2)).toLocaleString("en-IN")}</td>
                    </tr>
                  )
                })
              }
            </tbody>
            :
            <tbody>
              <tr>
                <td colSpan={6}>
                  <div className='no-data-found'>
                    <div className='text-center'>
                      <img src={noDataFound} alt="no-data-found" className='img-fluid' />
                      <p className='mt-3'>No-Data Found</p>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
        }
      </table>
    </div>
  );
}

export default DataTable;